import { render, staticRenderFns } from "./Payplans.vue?vue&type=template&id=205ae8fc"
import script from "./Payplans.vue?vue&type=script&lang=js"
export * from "./Payplans.vue?vue&type=script&lang=js"
import style0 from "./Payplans.vue?vue&type=style&index=0&id=205ae8fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports